var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.036.099A24 24 0 0 1 87.5 5.035a23.326 23.326 0 0 1 1.52 34.648l-7.081 6.921a40 40 0 0 1-29.487 11.483 15.12 15.12 0 0 0-11.483 4.24L29.527 73.77l3.28 3.281-18.684 18.644L0 81.572l18.684-18.644 3.281 3.28 11.443-11.442a15.12 15.12 0 0 0 4.24-11.483 40 40 0 0 1 11.483-29.486l6.362-6.362A24 24 0 0 1 71.036.1Zm3.421 38.903 7.082-7.041.08.08a12.64 12.64 0 0 0 0-17.924l-.96-.84a13.243 13.243 0 0 0-17.685 1.64l-6.241 6.401C49.93 27.96 46.09 39.843 50.972 44.764c4.88 4.92 16.723.96 23.485-5.762ZM59.546 75.657A14.084 14.084 0 1 1 84.81 88.114a14.084 14.084 0 0 1-25.264-12.457Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquash);
export default __webpack_public_path__ + "static/media/squash.5c8c9d082173874bcd46c484d0258481.svg";
export { ForwardRef as ReactComponent };